// Helper data/ora condivisi tra calendario evento e calendario globale.
// Funzioni pure (nessuna dipendenza da React): tenute qui per evitare le copie
// duplicate che vivevano nei singoli componenti.

export const WEEKDAYS = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];
export const DAY_MS = 24 * 60 * 60 * 1000;

// Chiave giorno locale "YYYY-MM-DD" (usata per raggruppare i match per giorno).
export const toLocalDateKey = (date: Date): string => {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// Inverso di toLocalDateKey: dalla chiave "YYYY-MM-DD" alla Date locale.
export const getDateFromLocalKey = (dateKey: string): Date => new Date(`${dateKey}T00:00:00`);

// Lunedì (inizio settimana) del giorno passato.
export const getWeekStart = (date: Date): Date => {
  const day = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const mondayOffset = (day.getDay() + 6) % 7;
  day.setDate(day.getDate() - mondayOffset);
  return day;
};

// I 7 giorni della settimana a partire dal lunedì passato.
export const getWeekDays = (weekStart: Date): Date[] =>
  Array.from({ length: 7 }, (_, index) => {
    const day = new Date(weekStart);
    day.setDate(weekStart.getDate() + index);
    return day;
  });

// Minuti trascorsi dalla mezzanotte (coordinata verticale nel time-grid).
export const minutesOfDay = (date: Date): number => date.getHours() * 60 + date.getMinutes();

// "HH:MM" da minuti dalla mezzanotte.
export const formatMinutes = (minutes: number): string =>
  `${String(Math.floor(minutes / 60)).padStart(2, "0")}:${String(minutes % 60).padStart(2, "0")}`;

// "HH:MM" (it-IT) da una Date.
export const formatClock = (date: Date): string =>
  date.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" });

// "HH:MM" da una data ISO (string) con guardia su valori assenti/non validi.
export const formatScheduledTime = (value: string | null): string | null => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return formatClock(date);
};

// ISO string -> valore per <input type="datetime-local"> ("YYYY-MM-DDTHH:MM"
// nel fuso locale). Stringa vuota se assente/non valido.
export const toDateTimeLocalValue = (value: string | null): string => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const offsetDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return offsetDate.toISOString().slice(0, 16);
};

// Valore di <input type="datetime-local"> -> ISO string (o null se vuoto).
export const toApiDateTimeValue = (value: string): string | null => {
  if (!value) return null;
  return new Date(value).toISOString();
};
